module.exports = __webpack_public_path__ + "static/img/3.1.b9c3563.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/2/eng/3.1.png
// module id = cXiw
// module chunks = 0